import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import cloneDeep from "lodash/cloneDeep";
import Loading from "./Loading";
import Form from "react-bootstrap/Form";
import * as api from "../api/api";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

import { Snackbar, Alert } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { toZonedTime } from "date-fns-tz";
import { fromZonedTime } from "date-fns-tz";

import addDays from "date-fns/addDays";
import format from "date-fns/format";

function FormInfo(props) {
  const { formsResponse, setFormsResponse, setInactiveForms } =
    useOutletContext();

  const { language } = useLanguage();
  const pageTitle = "FormInfo";
  const emptyForm = {
    name: "",
    helpText: "",
    created: "",
    modified: "",
    isDisabled: false,
    isTemplate: false,
    isSystem: false,
    sectionsAligned: false,
    isBillable: false,
    counter: 0,
    activeFrom: "",
    activeTo: "",
    templateFormId: 1,
    templateInfo: "Template information",
  };
  const [formInfo, setFormInfo] = useState(emptyForm);
  const [show, setShow] = useState(false);
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [snackbarData, setSnackbarData] = useState({
    vertical: "bottom",
    horizontal: "right",
  });
  const handleClose = () => setShow(false);
  const navigate = useNavigate();
  useEffect(() => {
    setFormInfo((prevFormInfo) => {
      return {
        ...prevFormInfo,
        ...emptyForm,
      };
    });
  }, []);

  const [tenantTimezoneId, setTenantTimezoneId] = useState("");

  useEffect(() => {
    api
      .getAppSettingsOfTenantByTenantId()
      .then((response) => {
        setTenantTimezoneId(response.data.object.timeZoneId);
      })
      .catch((error) => {});
  }, []);

  function handleFormChanges(e, dateField) {
    console.log(formInfo, e);

    try {
      if (e?.target?.type === "checkbox") {
        setFormInfo({
          ...formInfo,
          [e.target.name]: e.target.checked,
        });
      } else {
        setFormInfo({
          ...formInfo,
          [e.target.name]: e.target.value,
        });
      }
    } catch (exception) {
      // ✅ Instead of forcing UTC, reinterpret the picked date in tenant's timezone
      let utcDate = e ? fromZonedTime(e, tenantTimezoneId) : null;
      console.log("utcDate:", utcDate, utcDate.toISOString());

      const dateToInsert = utcDate
        .toISOString()
        .replace("T", " ")
        .replace("Z", "")
        .split(".")[0];

      if (dateField === "from") {
        setFormInfo({
          ...formInfo,
          activeFrom: utcDate ? dateToInsert : null,
        });
      } else {
        setFormInfo({
          ...formInfo,
          activeTo: utcDate ? dateToInsert : null,
        });
      }
    }
  }

  function handleCancelForm() {
    setFormInfo(emptyForm);
  }
  function handleDeleteForm(id) {
    setLoading(true);
    api
      .deleteFormById(id)
      .then((response) => {
        setLoading(false);
        handleClose();
        let targetId = parseInt(id);
        setInactiveForms((prevState) =>
          prevState.filter((form) => form.formId != targetId)
        );
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].deleteSnackbarMessage,
          show: true,
          severity: "success",
        });
        let newServices = removeTargetForm(formsResponse, targetId);
        setFormsResponse(newServices);

        // delayed the navigation so that the snackbar takes time to appear
        setTimeout(() => {
          navigate("/formsandfields/");
        }, 3000);

        // window.location.reload();
      })
      .catch((error) => {});
  }
  function convertDate(dtStr) {
    console.log(dtStr);

    try {
      const [dateStr, timeStr] = dtStr.split(" ");
      const dateParts = dateStr.split("-");
      const timeParts = timeStr.split(":");

      const newDtStr = `${dateParts[0]}-${dateParts[1]}-${dateParts[2]} ${
        timeParts[0]
      }:${timeParts[1]}:${"00"}`;
      return newDtStr;
    } catch (e) {
      try {
        const [dateStr, timeStr] = dtStr.split("T");
        const dateParts = dateStr.split("-");
        const timeParts = timeStr.split(":");

        const newDtStr = `${dateParts[0]}-${dateParts[1]}-${dateParts[2]} ${
          timeParts[0]
        }:${timeParts[1]}:${"00"}`;
        return newDtStr;
      } catch (e) {}
    }
    // console.log(newDtStr);
  }
  function updateFormName(services, formIdToUpdate, newName) {
    let newServices = cloneDeep(services);
    // this function is used to manipulate state of side bar
    function updateForms(forms, formIdToUpdate) {
      return forms.map((form) =>
        form.formId == formIdToUpdate ? { ...form, formName: newName } : form
      );
    }

    newServices.forEach((service) => {
      service.callLineForms = updateForms(
        service.callLineForms,
        formIdToUpdate
      );
      service.ddiForms = updateForms(service.ddiForms, formIdToUpdate);
      service.offlineForms = updateForms(service.offlineForms, formIdToUpdate);
      if (service.subServices) {
        updateFormName(service.subServices, formIdToUpdate, newName);
      }
    });
    return newServices;
  }
  function removeTargetForm(services, formIdToUpdate) {
    let newServices = cloneDeep(services);
    // this function is used to manipulate state of side bar
    function updateForms(forms, formIdToUpdate) {
      return forms.filter((form) => form.formId != formIdToUpdate);
    }

    newServices.forEach((service) => {
      service.callLineForms = updateForms(
        service.callLineForms,
        formIdToUpdate
      );
      service.ddiForms = updateForms(service.ddiForms, formIdToUpdate);
      service.offlineForms = updateForms(service.offlineForms, formIdToUpdate);
      if (service.subServices) {
        updateFormName(service.subServices, formIdToUpdate);
      }
    });
    return newServices;
  }
  function handleSaveForm() {
    //handling creation of new form

    // dummy data added for these attributes until client confirms where do they come from
    // add 00:00:00 to activeFrom and activeTO
    setLoading(true);
    const newFormInfo = {
      ...formInfo,
      [`activeFrom`]: formInfo.activeFrom
        ? convertDate(formInfo.activeFrom)
        : "",
      [`activeTo`]: formInfo.activeTo ? convertDate(formInfo.activeTo) : "",
    };

    // get the name of the user that is modifying this form,
    // this is probably the user that is currently logged in

    if (newFormInfo.name === "") {
      setLoading(false);
      setSnackbarData({
        ...snackbarData,
        message: strings[pageTitle][language].emptyNameError,
        show: true,
        severity: "error",
      });

      return;
    }

    if (newFormInfo.activeTo < newFormInfo.activeFrom) {
      console.log(newFormInfo.activeTo);
      if (newFormInfo.activeTo !== "") {
        console.log("empty");

        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].message,
          show: true,
          severity: "error",
        });
        setLoading(false);
        return;
      }
    }

    if (params.id === undefined) {
      // confirm that there isn't an already existing form with this name
      let forms = [];
      api.getAllForms().then((response) => {
        forms = response.data.object;
        console.log(forms);
        // now we can proceed to see if the new name is the same as an already existing one
        let selectedName = formInfo.name;
        let mappedNames = [];
        mappedNames = response.data.object.map((obj) => obj.name);

        console.log(mappedNames.includes(selectedName));

        if (mappedNames.includes(selectedName)) {
          //TODO: SHOW ERROR SNACKBAR
          setShowErrorSnackbar(true);
          setLoading(false);
        } else {
          api
            .insertForm(newFormInfo)
            .then((response) => {
              setLoading(false);
              setFormInfo(emptyForm);
              setShowConfirmMessage(true);
              //window.location.reload(false);
              console.log(response.data.object.formId);
              // here we update the unassigned forms state in the admin
              setInactiveForms((prevState) => [
                ...prevState,
                response.data.object,
              ]);
              let el = document.getElementById("admin-options-bar");
              setTimeout(() => {
                el?.scrollTo({
                  top: el.scrollHeight,
                  behavior: "smooth",
                });
              }, 500);

              navigate(`/formsandfields/${response.data.object.formId}`);
              /*const reloadWithDelay = () => {
                setTimeout(() => {
                  window.location.reload();
                }, 2000); // Adjust the delay time as needed (in milliseconds)
              };*/

              // Call the function
              //reloadWithDelay();
            })
            .catch((err) => {});
        }
      });
      console.log(forms);
    } else {
      api
        .updateFormById(params.id, newFormInfo)
        .then((response) => {
          setLoading(false);
          setShowConfirmMessage(true);
          // here instead of reloading we will update the form name directly in the forms state

          let targetId = parseInt(params.id);
          const newFilteredResponse = updateFormName(
            formsResponse,
            targetId,
            newFormInfo.name
          );
          console.log("new filtered responsesss: ", newFilteredResponse);
          setFormsResponse(newFilteredResponse);
          setInactiveForms((prevState) =>
            prevState.map((form) =>
              form.formId == targetId
                ? { ...form, formName: newFormInfo.name }
                : form
            )
          );
          setShowConfirmMessage(true);
        })
        .catch((err) => {});
    }
  }

  const [isLoading, setLoading] = useState(false);
  const [showConfirmMessage, setShowConfirmMessage] = useState(false);
  const [duplicating, setDuplicating] = useState(false);
  const [modifiedUser, setModifiedUser] = useState();

  const params = useParams();
  let location = useLocation();

  const showPreview = () => {
    // Calculate the center position of the screen
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = 1200; // Set your desired width
    const windowHeight = 800; // Set your desired height

    const left = (screenWidth - windowWidth) / 2;
    const top = (screenHeight - windowHeight) / 2;

    // `/formsandfields/${formInfo.formId}/previewForm`
    window.open(
      `/previewForm/${formInfo.formId}`,
      "_blank",
      `left=${left},top=${top},width=${windowWidth},height=${windowHeight}`
    );
  };

  useEffect(() => {
    let isDuplicating = location?.state !== null ? true : false;
    setDuplicating(isDuplicating);
    if (params.id) {
      setLoading(true);
      api.getFormById(params.id).then((response) => {
        setLoading(false);

        api
          .getUserById(response.data.object.modifiedByUserId)
          .then((response) => {
            setModifiedUser(response.data.object.name);
          });

        setFormInfo(response.data.object);
      });
    } else if (isDuplicating) {
      setLoading(true);
      api.getFormById(location.state.formId).then((response) => {
        setLoading(false);

        setFormInfo({
          ...response.data.object,
          formId: "",
        });
      });
    } else {
      setFormInfo(emptyForm);
    }
  }, [location]);

  function tenantSettingsSensitiveDate(utcString) {
    if (!utcString) return null;

    // 1. Parse backend "2025-09-11 07:00:00" as UTC
    const parsedUtc = new Date(utcString.replace(" ", "T") + "Z");

    // 2. Convert UTC → tenant timezone
    return toZonedTime(parsedUtc, tenantTimezoneId);
  }

  return (
    <div className="main-content">
      {isLoading ? <Loading /> : ""}
      <p className="main-content__title">
        <Snackbar
          open={snackbarData.show}
          anchorOrigin={{
            vertical: snackbarData.vertical,
            horizontal: snackbarData.horizontal,
          }}
          autoHideDuration={3000}
          onClose={() => setSnackbarData({ ...snackbarData, show: false })}
        >
          <Alert severity={snackbarData.severity}>{snackbarData.message}</Alert>
        </Snackbar>
        {params.id ? (
          strings[pageTitle][language].editFormLabel
        ) : duplicating ? (
          <b style={{ fontSize: 20 }}>
            {strings[pageTitle][language].duplicatingFormLabel}
          </b>
        ) : (
          strings[pageTitle][language].addNewFormLabel
        )}
      </p>
      <div class="service-details-grid">
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].nameLabel}
        </div>
        <div class="grid-item" style={{ width: "100%" }}>
          <Form.Control
            name="name"
            type="text"
            value={formInfo.name}
            onChange={(e) => handleFormChanges(e)}
          />
        </div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].helpTextLabel}
        </div>
        <div class="grid-item" style={{ width: "100%" }}>
          <Form.Control
            name="helpText"
            as="textarea"
            rows={5}
            value={formInfo.helpText}
            onChange={handleFormChanges}
          />
        </div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].sectionAlignmentLabel}
        </div>
        <div class="grid-item">
          <input
            type="checkbox"
            name="sectionsAligned"
            id=""
            checked={formInfo.sectionsAligned}
            onChange={handleFormChanges}
          />
        </div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].billableLabel}
        </div>
        <div class="grid-item">
          <input
            type="checkbox"
            name="isBillable"
            id=""
            checked={formInfo.isBillable}
            onChange={handleFormChanges}
          />
        </div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].activeFromLabel}
        </div>
        <div class="grid-item">
          <div className="d-flex gap-3">
            <DatePicker
              selected={
                formInfo.activeFrom
                  ? tenantSettingsSensitiveDate(formInfo.activeFrom)
                  : null
              }
              onChange={(e) => handleFormChanges(e, "from")}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="Time"
              dateFormat={
                language === "en" ? "dd-MM-yyyy HH:mm" : "dd.MM.yyyy HH:mm"
              }
            />

            {strings[pageTitle][language].to}
            <DatePicker
              selected={
                formInfo.activeTo
                  ? new Date(tenantSettingsSensitiveDate(formInfo.activeTo))
                  : null
              }
              onChange={(e) => handleFormChanges(e)}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="Time"
              dateFormat={
                language === "en" ? "dd-MM-yyyy HH:mm" : "dd.MM.yyyy HH:mm"
              }
            />
          </div>
        </div>
        <div class="grid-item" className="grid-item-title">
          {strings[pageTitle][language].numberOfActivationLabel}
        </div>
        <div name="counter" class="grid-item">
          {formInfo.counter}
        </div>
      </div>

      <p>
        {strings[pageTitle][language].lastEditedLabel +
          " " +
          (formInfo.modified ? formInfo.modified.substring(0, 10) : "") +
          strings[pageTitle][language].byUser}{" "}
        {modifiedUser}
      </p>
      <div style={{ borderBottom: "1px solid black", marginLeft: "1em" }}></div>
      <div className="d-flex justify-content-end">
        {params.id ? (
          <>
            {formInfo.counter == 0 ? (
              <button
                className="button-round danger"
                style={{ alignSelf: "flex-end", margin: "1em" }}
                onClick={() => {
                  setShow(true);
                }}
              >
                {strings[pageTitle][language].deleteButtonLabel}
              </button>
            ) : (
              ""
            )}
            <button
              className="button-round"
              style={{ alignSelf: "flex-end", margin: "1em" }}
              onClick={showPreview}
            >
              {strings[pageTitle][language].previewButtonLabel}
            </button>
          </>
        ) : (
          ""
        )}
        <button
          className="button-round cancel"
          style={{ alignSelf: "flex-end", margin: "1em" }}
          onClick={handleCancelForm}
        >
          {strings[pageTitle][language].cancelButtonLabel}
        </button>
        <button
          className="button-round"
          style={{ alignSelf: "flex-end", margin: "1em" }}
          onClick={handleSaveForm}
        >
          {strings[pageTitle][language].saveButtonLabel}
        </button>

        <Snackbar
          anchorOrigin={{
            vertical: snackbarData.vertical,
            horizontal: snackbarData.horizontal,
          }}
          open={showConfirmMessage}
          autoHideDuration={3000}
          onClose={() => setShowConfirmMessage(false)}
        >
          <Alert severity={"success"}>
            {strings[pageTitle][language].savedSuccessfullyMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          anchorOrigin={{
            vertical: snackbarData.vertical,
            horizontal: snackbarData.horizontal,
          }}
          open={showErrorSnackbar}
          autoHideDuration={3000}
          onClose={() => setShowConfirmMessage(false)}
        >
          <Alert severity={"error"}>
            {strings[pageTitle][language].formExistsErrorMessage}
          </Alert>
        </Snackbar>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].deleteConfirmationTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {strings[pageTitle][language].deleteConfirmationBody}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            {strings[pageTitle][language].cancel}
          </Button>
          <Button variant="danger" onClick={() => handleDeleteForm(params.id)}>
            {strings[pageTitle][language].deleteButtonLabel}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default FormInfo;
